import { render, staticRenderFns } from "./ComplicateDialog.vue?vue&type=template&id=4b96531a&"
import script from "./ComplicateDialog.vue?vue&type=script&lang=js&"
export * from "./ComplicateDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports